export function cleanLegacyTermsPolicy(root = document) {
  const rte = root.querySelector('.ls-legal-policy--terms .shopify-policy__body .rte')
    || root.querySelector('.ls-legal-policy--terms #MainContent .rte');
  const termsContainer = rte?.querySelector('.terms-container');

  if (!rte || !termsContainer) return false;

  let node = rte.firstChild;
  while (node && node !== termsContainer) {
    const nextNode = node.nextSibling;
    rte.removeChild(node);
    node = nextNode;
  }

  termsContainer.querySelectorAll('.section').forEach((section) => {
    if (!section.textContent.trim()) section.remove();
  });

  termsContainer.querySelectorAll('.toc-links a[href^="#"]').forEach((link) => {
    const targetId = link.getAttribute('href')?.slice(1);
    if (targetId && !root.getElementById(targetId)) link.closest('li')?.remove();
  });

  return true;
}

export function cleanContactInformationPolicy(root = document) {
  const rte = root.querySelector('.ls-legal-policy--contact .shopify-policy__body .rte');
  const content = rte?.querySelector('div');
  const config = root.getElementById('LsContactPolicyConfig');

  if (!rte || !content || !config) return false;

  const duplicateTitle = Array.from(content.children).find((child) => child.tagName === 'H1');
  duplicateTitle?.remove();

  Array.from(content.children).forEach((row) => {
    const normalizedText = row.textContent.replace(/\u00a0/g, ' ').trim();

    if (!normalizedText) {
      row.remove();
      return;
    }

    if (/^Company Address:/i.test(normalizedText)) {
      row.remove();
      return;
    }

    if (/^Email:/i.test(normalizedText)) row.classList.add('ls-policy-contact__detail');
    if (/^Phone:/i.test(normalizedText)) {
      row.classList.add('ls-policy-contact__detail');
      row.classList.add('ls-policy-contact__detail--phone');
    }
  });

  Array.from(rte.children).forEach((child) => {
    const normalizedText = child.textContent.replace(/\u00a0/g, ' ').trim();
    if (child !== content && !normalizedText) child.remove();
  });

  if (!content.querySelector('.ls-policy-contact__detail--whatsapp')) {
    const whatsappRow = root.createElement('div');
    const whatsappLabel = root.createElement('strong');
    const whatsappLink = root.createElement('a');

    whatsappRow.className = 'ace-line ls-policy-contact__detail ls-policy-contact__detail--whatsapp';
    whatsappLabel.textContent = `${config.dataset.whatsappLabel}:`;
    whatsappLink.href = config.dataset.whatsappUrl;
    whatsappLink.target = '_blank';
    whatsappLink.rel = 'noopener';
    whatsappLink.textContent = config.dataset.whatsappNumber;
    whatsappRow.append(whatsappLabel, root.createTextNode(' '), whatsappLink);

    const phoneRow = content.querySelector('.ls-policy-contact__detail--phone');
    if (phoneRow) phoneRow.insertAdjacentElement('afterend', whatsappRow);
    else content.append(whatsappRow);
  }

  content.classList.add('ls-policy-contact');
  return true;
}

export function cleanStrippedPolicyStyles(root = document) {
  const main = root.querySelector('.ls-legal-policy #MainContent');
  if (!main || !root.createTreeWalker) return 0;
  const walker = root.createTreeWalker(main, 4);
  const obsolete = [];
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (node.parentElement?.closest('style, script')) continue;
    if (/^\s*(?:\.ls-policy\s*\{|body:has\(\.ls-return-policy\)\s*\{)/.test(node.textContent)) obsolete.push(node);
  }
  obsolete.forEach(node => node.remove());
  return obsolete.length;
}

function initializePolicyPage() {
  cleanStrippedPolicyStyles();
  cleanLegacyTermsPolicy();
  cleanContactInformationPolicy();
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePolicyPage, { once: true });
  } else {
    initializePolicyPage();
  }
}
